import { Drawer, Hidden, Paper, makeStyles } from "@material-ui/core";
import { Logo, Navigation } from "@hubcapp/components";
import { NavBarProps } from "./types";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { SupportButton } from "../";
import { useAuth } from "@hubcapp/context";
import { useQueryGetInstructorPropositionDetails } from "@hubcapp/hooks";
import React, { Fragment, useEffect } from "react";
import clsx from "clsx";
import navigationConfig from "./navigationConfig";

const useStyles = makeStyles(theme => ({
  root: {
    overflowY: "auto",
  },
  content: {
    padding: theme.spacing(2, 2, 3, 2),
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-between",

    [theme.breakpoints.up("lg")]: {
      padding: theme.spacing(4, 3, 4, 3),
    },
  },
  profile: {
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.grey[200]}`,
  },
  logo: {
    display: "block",
    margin: `0 auto ${theme.spacing(3)}px auto`,
  },
  supportButton: {
    marginTop: "auto",
  },
}));

const NavBar = ({ openMobile, onMobileClose, className }: NavBarProps) => {
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    if (openMobile) {
      onMobileClose && onMobileClose();
    }
  }, [location.pathname]);

  const { instructor } = useAuth();
  const {
    data: instructorDetailsData,
    loading,
  } = useQueryGetInstructorPropositionDetails(instructor.id);

  const NavBarContent = loading ? null : (
    <div className={classes.content}>
      <Hidden lgUp>
        <RouterLink to="/">
          <Logo rootClass={classes.logo} />
        </RouterLink>
      </Hidden>
      <nav>
        {navigationConfig(
          instructor,
          instructorDetailsData?.instructor?.propositions ?? [],
        ).map(list => (
          <Navigation
            component="div"
            key={list.title}
            pages={list.pages}
            title={list.title}
          />
        ))}
      </nav>
      <div className={classes.supportButton}>
        <SupportButton />
      </div>
    </div>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          data-test="app-drawer"
        >
          <div className={clsx(classes.root, className)}>{NavBarContent}</div>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Paper
          className={clsx(classes.root, className)}
          elevation={1}
          square
          data-test="app-sidebar"
        >
          {NavBarContent}
        </Paper>
      </Hidden>
    </Fragment>
  );
};

export default NavBar;
